// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input.identifier-input[data-v-685a778f] .v-input__slot{padding-left:0!important}.v-input[data-v-685a778f] .v-input__prepend-inner{margin:0!important;padding-left:0;padding-right:4px}.identifier-input .v-card[data-v-685a778f]{font-size:14px;padding-left:8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.identifier-input .v-text-field__input[data-v-685a778f]{padding-left:0!important;border-radius:16px}", ""]);
// Exports
module.exports = exports;
